import React, { Component } from 'react';
import _ from 'lodash';

export default class FilterList extends Component {
  state = {
    filterKey: null,
    filterValue: null
  };
  handleChangeFilter = (key, value) => {
    this.setState({ filterKey: key, filterValue: value });
  };
  render() {
    const { filterKey, filterValue } = this.state;
    const { dataSource, renderHeader, renderList } = this.props;
    let items = dataSource;
    if (filterKey && filterValue) {
      items = _.filter(items, { [filterKey]: filterValue });
      // items = _.filter(items, item => {
      //   return _.includes(_.get(item, filterKey), filterValue);
      // });
      // items = _.filter(dataSource, { [filterKey]: filterValue });
    }
    return (
      <div className="filter-list">
        {renderHeader({ onChangeFilter: this.handleChangeFilter, filterValue })}
        {renderList(items)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterList.js